export const defaultAxisLabelsStyle = {
  labels: {
    style: {
      fontSize: '10px',
      fontWeight: '400',
      color: '#000',
    },
  },
};
